"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { CircleCheck } from "lucide-react";
const categories = [{
  title: "ENGINEERING & CONSULTING SERVICES",
  services: [{
    name: "Control System Design & Specification",
    desc: "comprehensive design and specification of control systems for industrial automation"
  }, {
    name: "Process & Production Line Assessments",
    desc: "thorough evaluation of existing production processes to identify automation opportunities"
  }, {
    name: "Electrical Design & CAD Drafting",
    desc: "detailed electrical schematics and CAD drawings for system implementation"
  }, {
    name: "System Feasibility Studies",
    desc: "analysis of technical and economic feasibility of proposed automation solutions"
  }]
}, {
  title: "ROBOTICS SOLUTIONS\n",
  services: [{
    name: "Robotic System Design Programming Integration & Deployment",
    desc: "complete design, programming, and deployment of robotic systems"
  }, {
    name: "Autonomous Mobile Robots AMRs",
    desc: "implementation of autonomous mobile robots for material handling and logistics"
  }, {
    name: "End-of-Arm Tooling EOAT Design",
    desc: "custom gripper and tooling design for robotic applications"
  }, {
    name: "Robotics Retrofits & Upgrades",
    desc: "modernization and enhancement of existing robotic systems"
  }, {
    name: "Robotics Maintenance & Support",
    desc: "ongoing maintenance and technical support for robotic equipment"
  }, {
    name: "Vision-Guided Robotics",
    desc: "integration of vision systems for precision robotic operations"
  }]
}, {
  title: "SOFTWARE & DATA SERVICES\n",
  services: [{
    name: "HMI SCADA & MES Integration",
    desc: "human-machine interface and manufacturing execution system integration"
  }, {
    name: "Custom PLC Programming",
    desc: "tailored programmable logic controller programming for specific applications"
  }, {
    name: "Data Historian Setup",
    desc: "implementation of data logging and historical analysis systems"
  }, {
    name: "IIoT Enablement",
    desc: "industrial internet of things integration for connected systems"
  }, {
    name: "Energy Management Solutions",
    desc: "optimization and monitoring of energy consumption"
  }, {
    name: "Building Management Systems & Building Automation Systems",
    desc: "automated control of building systems and facilities"
  }]
}];
function CategorySection({
  category,
  index
}: {
  category: (typeof categories)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      <Card className="text-card-foreground flex flex-col gap-6 h-full border border-gray-200 shadow-md rounded-lg bg-white overflow-hidden">
        <CardHeader className="bg-muted/20 pt-8 pb-6 min-h-[160px] flex flex-col items-start overflow-visible break-words">
          <CardTitle className="text-2xl text-ring uppercase whitespace-normal flex flex-wrap items-start justify-start !font-serif !font-normal md:text-3xl">
            {category.title}
          </CardTitle>
        </CardHeader>
        <CardContent className="p-6 flex flex-col gap-6">
          {category.services.map((service, sIdx) => <div key={sIdx} className="flex gap-4 group">
              <CircleCheck className="w-5 h-5 text-ring shrink-0 mt-0.5 opacity-80 group-hover:opacity-100 transition-opacity" />
              <div className="flex flex-col gap-3">
                <h4 className="text-[#1B1B1B] font-bold text-xl font-['Merriweather']">
                  {service.name}
                </h4>
                <p className="text-[#1B1B1B] text-base font-['Muli'] leading-relaxed">
                  {service.desc}
                </p>
              </div>
            </div>)}
        </CardContent>
      </Card>
    </div>;
}
export default function CoreExpertise() {
  return <section data-section-id="236818" id="our-automation-services" className="bg-[#F6F6F6] text-[#1B1B1B] py-12 md:py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-0">
          {categories.map((category, i) => <CategorySection key={i} category={category} index={i} />)}
        </div>
      </div>
    </section>;
}